import { FieldRenderProps } from '@progress/kendo-react-form';
import { FixedSchedule, FixedScheduleValue } from './FixedSchedule';
import {
  RotationalSchedule,
  RotationalScheduleValue,
} from './RotationalSchedule';
import { FlexibleSchedule, FlexibleScheduleValue } from './FlexibleSchedule';

export type { FixedScheduleValue } from './FixedSchedule';
export type { RotationalScheduleValue } from './RotationalSchedule';
export type { FlexibleScheduleValue } from './FlexibleSchedule';

export type VariableScheduleVariant = 'fixed' | 'rotational' | 'flexible';

export type VariableScheduleValue =
  | FixedScheduleValue
  | RotationalScheduleValue
  | FlexibleScheduleValue;

export interface VariableScheduleProps
  extends Omit<Partial<FieldRenderProps>, 'onChange' | 'value'> {
  onChange: (e: { value: VariableScheduleValue }) => void;
  value?: VariableScheduleValue;
  variant: VariableScheduleVariant;
  processedProps?: boolean;
}

const VariableSchedule = ({
  onChange,
  value,
  variant = 'fixed',
  onBlur,
  processedProps,
}: VariableScheduleProps) => {
  if (variant === 'rotational') {
    return (
      <RotationalSchedule
        onChange={onChange}
        value={value as RotationalScheduleValue}
        onBlur={onBlur}
        processedProps={processedProps}
      />
    );
  }
  if (variant === 'flexible') {
    return (
      <FlexibleSchedule
        onChange={onChange}
        value={value as FlexibleScheduleValue}
        onBlur={onBlur}
        processedProps={processedProps}
      />
    );
  }
  return (
    <FixedSchedule
      onChange={onChange}
      value={value as FixedScheduleValue}
      onBlur={onBlur}
      processedProps={processedProps}
    />
  );
};

export default VariableSchedule;
